export var PANTALLA_CADUCADO_ID = 'pantalla-cad';
export var PANTALLA_ANTERIOR_ID = 'pantalla-anterior';
export var PANTALLA_PORTADA_ID = 'pantalla-portada';
export var PANTALLA_INDICE_ID = 'pantalla-indice';
export var PANTALLA_LIBRO_ID = 'pantalla-libro';
export var PANTALLA_VENTANA_ID = 'pantalla-ventana';
export var PRIMERA_VENTANA_ID = 'primera-ventana';
export var SEGUNDA_VENTANA_ID = 'segunda-ventana';
export var MODO_DOS_PAGINAS = 'dosPaginas';